module.exports = __webpack_public_path__ + "static/media/apcci.c610fa3d.png";